import React from 'react';
import Announcement from './Announcement';
import { useAnnouncements } from '../../service/service';

const Announcements = () => <Announcement className="announcement" {...useAnnouncements()} />;
export default Announcements;
